import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { LanguageProvider } from "@/context/LanguageContext";
import { SelectedCountryProvider } from "@/context/SelectedCountryContext";
import CountryGate from "@/components/CountryGate";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Countries from "@/pages/Countries";
import CountryDetail from "@/pages/CountryDetail";
import Visa from "@/pages/Visa";
import Principles from "@/pages/Principles";
import Quiz from "@/pages/Quiz";
import Checklist from "@/pages/Checklist";
import Chat from "@/pages/Chat";
import About from "@/pages/About";
import Locals from "@/pages/Locals";
import Airports from "@/pages/Airports";

function App() {
  return (
    <LanguageProvider>
      <SelectedCountryProvider>
        <BrowserRouter>
          <div className="App min-h-screen flex flex-col bg-[#F8F9FA]">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/countries" element={<Countries />} />
                <Route path="/countries/:slug" element={<CountryDetail />} />
                <Route path="/visa" element={<Visa />} />
                <Route path="/principles" element={<Principles />} />
                <Route path="/quiz" element={<Quiz />} />
                <Route path="/checklist" element={<Checklist />} />
                <Route path="/locals" element={<Locals />} />
                <Route path="/airports" element={<Airports />} />
                <Route path="/chat" element={<Chat />} />
                <Route path="/about" element={<About />} />
              </Routes>
            </main>
            <Footer />
            <CountryGate />
          </div>
        </BrowserRouter>
      </SelectedCountryProvider>
    </LanguageProvider>
  );
}

export default App;
